<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded filters">
            <h2 class="panel-header">Cerca</h2>

            <vue-form-generator :schema="schema" :model="place" :options="formOptions"></vue-form-generator>
              <br>
              Filtri:<br>
              <input id="filter-bestprice" class="filter-checkbox" type="checkbox" value="1" :checked="this.filters.filtro_bestprice" @change="setFilter('filtro_bestprice',$event)" />
              <label for="filter-bestprice">Solo pi&ugrave; Economici</label><br>
              <div v-if="this.fuel==1 || this.fuel==8">
                <input id="filter-selfservice" class="filter-checkbox" type="checkbox" value="1" :checked="this.filters.filtro_selfservice" @change="setFilter('filtro_selfservice',$event)" />
                <label for="filter-selfservice">Solo self-service</label>
              </div>
              <input id="filter-autostradali" class="filter-checkbox" type="checkbox" value="1" :checked="this.filters.filtro_autostradali" @change="setFilter('filtro_autostradali',$event)" />
              <label for="filter-autostradali">Solo autostradale</label><br>
              <div v-if="this.fuel==1 || this.fuel==8">
                <input id="filter-biometano" class="filter-checkbox" type="checkbox" value="1" :checked="this.filters.filtro_biometano" @change="setFilter('filtro_biometano',$event)" />
                <label for="filter-biometano">Solo bio metano</label>
                <br>
                <input id="filter-hiperformance" class="filter-checkbox" type="checkbox" value="1" :checked="this.filters.filtro_hiperformance" @change="setFilter('filtro_hiperformance',$event)" />
                <label for="filter-hiperformance">Solo LCNG <a href="https://www.ecomotori.net/guide/l-cng-metano-hi-performance/" target="_blank">Hi-Performance</a></label>
              </div>
        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            "vue-form-generator": VueFormGenerator.component
        },
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            setPlace(_place) {
                var $scope = this;

                if (!_place || !_place.geometry) return;

                this.latLng = {
                    lat: _place.geometry.location.lat(),
                    lng: _place.geometry.location.lng(),
                };

                for(var i=0; i<_place.address_components.length; i++) {
                    let _cmp = _place.address_components[i];

                    if(_cmp.types.indexOf('country') != -1) {
                        $scope.country_iso = _cmp.short_name.toLowerCase();
                    }
                }

                serverBus.$emit("positionChanged",{
                    latLng: $scope.latLng,
                    country_iso: $scope.country_iso
                });
            },
            setFilter(filter, _self) {
              serverBus.$emit("changeFilter", {
                filter: filter,
                checked: _self.target.checked,
              });
            }
        },
        data() {
            var $scope = this;
            return {
                description: '',
                latLng: {},
                country_iso: null,
                fuel: this.$parent.$parent.$parent.$parent.fuel,
                filters: this.$parent.$parent.$parent.$parent.filters,
                place: {},
                schema: {
                    fields: [{
                        type: "googleAddress",
                        label: "Cerca",
                        model: "from",
                        placeholder: "Inserisci un indirizzo o un punto di interesse",
                        onPlaceChanged: function(value, place, rawPlace, model, schema) {
                            $scope.setPlace(rawPlace);
                        },
                        required: true
                    }]
                },
                formOptions: {
                    validateAfterChanged: true
                }
            };
        },
        created() {
          serverBus.$emit('pageChanged',{page:'MapSearch'});
        }
    }

</script>
<style>
input.filter-checkbox{
  margin: 10px 3px 10px 4px;
}
.filters label{
  font-weight: normal;
}
</style>